import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const JerseyIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M4.4 1a.4.4 0 0 0-.4.4v3.772a2 2 0 0 1-.586 1.414l-.828.828A2 2 0 0 0 2 8.828V14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8.828a2 2 0 0 0-.586-1.414l-.828-.828A2 2 0 0 1 12 5.172V1.4a.4.4 0 0 0-.4-.4H11a1 1 0 0 0-1 1 2 2 0 1 1-4 0 1 1 0 0 0-1-1h-.6ZM7 6a1 1 0 0 0-1 1v.5a.5.5 0 0 0 .5.5H7v2h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H9V6.5a.5.5 0 0 0-.5-.5H7Z"
		></path>
	</svg>
))
